<template>
  <div class="content">
    <div class="box">
      <div class="title">
        <p>{{ name }}</p>
      </div>
      <div class="li-box" v-for="item in list" :key="item.contentCode|| item.contentTitle" @click="() => {item.fileName ? down(item) : goDetail(item);}">
        <div>{{ item.fileName || item.contentTitle }}</div>
        <div>
          <span style="float: right">{{
            String(item.createTime).split(" ")[0]
          }}</span>
        </div>
      </div>
      <div style="text-align: center; margin: 20px 0; height: 30px">
        <a-pagination showQuickJumper showSizeChanger :pageSizeOptions="pageSizeOptions" :pageSize="pageSize" :total="total" :showTotal="(total) => `总共 ${total} 条`" :itemRender="itemRender" @change="onChange" @showSizeChange="onShowSizeChange">
        </a-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getAnnounce } from "@/api/homeIndex.js";
import { downloadFile } from "@/api/file.js";
import { getTable } from "../../../api/goaborad";

export default {
  name: "middle-content",
  data () {
    return {
      pageSizeOptions: ["10", "20", "30"],
      total: 0,
      list: [],
      name: "",
      pageSize: 10
    };
  },
  created () {
    this.getList();
    this.name = this.$route.query.name;
    console.log(this.name);
  },
  methods: {
    down (i) {
      let baseUrl =
        process.env.NODE_ENV === "development"
          ? "http://10.11.0.104:55000"
          : "http://10.10.152.115:55000";
      downloadFile(
        `/api/cloud-fastdfs/fastdfs/download/file/${i.tenantCode}/${i.appCode}?fileCode=${i.fileCode}`,
        i.fileName
      );
    },
    goDetail (item) {
      const type = this.$route.query.type || ""
      this.pushRouter(
        `/guide?contentCode=${item.contentCode}&type=${type}&linkname=${this.$route.query.linkname||this.$route.query.name}/详情`
      );
    },
    getList (page) {
      const code = this.$route.query.moduleCode;
      const type = this.$route.query.type;
      const typeCode = this.$route.query.typeCode;
      // if (type === 'contentDownload') {
      //   getTable('', code).then(res => {
      //     this.list = this._.get(res, "data.records", []);
      //     this.total = this._.get(res, "data.total", 0);
      //   })
      // } else {
      getAnnounce(page, this.pageSize, code, type, typeCode).then((res) => {
        this.list = this._.get(res, "data.records", []);
        this.total = this._.get(res, "data.total", 0);
      });
      // }
    },
    onChange (pageNumber) {
      console.log(pageNumber);
      this.getList(pageNumber, 10);
    },
    onShowSizeChange (current, pageSize) {
      this.page = current;
      this.pageSize = pageSize;
      this.getList();
    },
    itemRender (current, type, originalElement) {
      if (type === "prev") {
        return (
          <li class="ant-pagination-item">
            <a>上页</a>
          </li>
        );
      } else if (type === "next") {
        return (
          <li class="ant-pagination-item">
            <a>下页</a>
          </li>
        );
      }
      return originalElement;
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
  margin-bottom: 50px;
}
.box {
  width: 1140px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
}
.title {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 41px;
  text-align: left;
  margin-top: 30px;
  & > p {
    display: inline-block;
    padding-bottom: 5px;
    border-bottom: 2px solid #cbb486;
    margin-bottom: 0;
  }
}
.li-box {
  display: flex;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #eeeeee;
  cursor: pointer;
  & > div:nth-of-type(1) {
    /* flex: 1; */
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3d4652;
    line-height: 80px;
    &:hover {
      color: #cbb486;
    }
  }
  & > div:nth-of-type(1)::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #cbb486;
    margin-right: 10px;
    transform: translateY(-2px);
  }
  & > div:nth-of-type(2) {
    flex: 100px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #bcbec0;
    text-align: right;
    line-height: 80px;
  }
}
/deep/ .ant-pagination-item-active {
  border: none;
  background: #cbb486;
}
/deep/ .ant-pagination-item-active a {
  color: white;
}
/deep/ .ant-pagination-item:hover {
  background: #cbb486;
  border: none;
  color: white;
}
/deep/ .ant-pagination-item:hover a {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/announcement/siderContent-01.vue